import { render, staticRenderFns } from "./SeccionCargosDestinosPage.vue?vue&type=template&id=c0c548fc"
import script from "./SeccionCargosDestinosPage.js?vue&type=script&lang=js&external"
export * from "./SeccionCargosDestinosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports